import type { MailboxInfo } from "owa-client-types";
import { getIsFocusedInboxEnabled } from "owa-session-store";
import setFocusedInboxOnOff from "owa-mail-focused-inbox-config/lib/actions/setFocusedInboxOnOff";

export function onToggleFocusedInbox(mailboxInfo: MailboxInfo): void {
    const isFocusedInboxEnabled = !!getIsFocusedInboxEnabled(mailboxInfo);
    
    setFocusedInboxOnOff(!isFocusedInboxEnabled, false /* skipServiceRequest */, mailboxInfo);
}
